import { getApiBaseUrl } from '~/utils'

export const state = () => ({
  ancList: []
})

export const mutations = {
  SET_ANC_LIST (state, list) {
    console.log('SET_ANC_LIST 호출됨:', list)
    state.ancList = list
  },
  TOGGLE_ANC_ITEM (state, { pdNo, ancYn }) {
    if (ancYn === 'Y') {
      state.ancList.push({ pdNo })
    } else {
      state.ancList = state.ancList.filter(i => i.pdNo !== pdNo)
    }
  }
}

export const actions = {
  async fetchAncList ({ commit, rootGetters }) {
    try {
      const mbMngNo = rootGetters['session/getMbMngNo']
      console.log('mbMngNo:', mbMngNo)
      console.log('mbMngNo 타입:', typeof mbMngNo)

      if (!mbMngNo || mbMngNo === 'undefined' || mbMngNo === '') {
        console.log('유효하지 않은 mbMngNo - 로그인 필요')
        commit('SET_ANC_LIST', [])
        return []
      }

      console.log('판매알림신청 API 호출 시작 - mbMngNo:', mbMngNo)
      const response = await this.$axios.post(getApiBaseUrl() + '/pd/pdm/pdNtcn/selOpRunNtcnPdNoList', { mbMngNo })

      const list = response.data?.data?.map(item => ({
        pdNo: item.pdNo
      })) || []

      commit('SET_ANC_LIST', list)
      return list
    } catch (error) {
      console.error('판매알림신청 목록 조회 실패:', error)
      commit('SET_ANC_LIST', [])
    }
  },

  async toggleAnc ({ commit }, { pdNo, mbMngNo, currentAncYn }) {
    try {
      const params = [{ pdNo, mbMngNo }]
      const url = currentAncYn === 'Y' ? '/pdo/delOpRunNtcn' : '/pdo/regOpRunNtcn'

      const res = await this.$axios.post(getApiBaseUrl() + url, params)
      if (res.data.success) {
        if (currentAncYn === 'Y') {
          const newAncYn = currentAncYn === 'Y' ? 'N' : 'Y'
          commit('TOGGLE_ANC_ITEM', { pdNo, ancYn: newAncYn })
          return newAncYn
        } else if (res.data.data.success) {
          const newAncYn = currentAncYn === 'Y' ? 'N' : 'Y'
          commit('TOGGLE_ANC_ITEM', { pdNo, ancYn: newAncYn })
          return newAncYn
        } else if (res.data.data.message !== 'INSERT') {
          return res.data.data.message
        }
      }
    } catch (e) {
      console.error('판매알림 토글 실패:', e)
      throw e
    }
  }
}
